import React from 'react';
import heroImage from '../assets/images/hero1.jpg';

const AboutSection = () => {
  return (
    <section className="bg-white py-24">
      <div className="mx-auto flex max-w-6xl flex-col gap-16 px-6 lg:flex-row lg:items-center">
        <div className="flex-1 space-y-6">
          <span className="inline-flex items-center rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-emerald-600">
            About Us
          </span>
          <h2 className="text-3xl font-bold text-slate-900 sm:text-4xl">We personalise every order like a trusted neighbour</h2>
          <p className="text-lg text-slate-600">
            Dial TPR started to make local shopping effortless for families that rely on neighbourhood stores. Instead of juggling multiple apps, you simply call us. We speak directly with the shops you prefer, keep them updated on your needs, and ensure every order is billed with their official invoice.
          </p>
          <p className="text-base text-slate-600">
            Our operations team tracks every request from call to delivery, coordinating riders, bills, and order updates in real time. The result is a transparent experience for customers and a dependable order flow for partner stores.
          </p>
          <div className="grid gap-6 sm:grid-cols-2">
            <div className="rounded-2xl border border-emerald-100 bg-emerald-50/80 p-6 shadow-sm shadow-emerald-100">
              <h3 className="text-lg font-semibold text-emerald-700">Why customers trust us</h3>
              <p className="mt-2 text-sm text-slate-600">
                A real person answers every call, confirms item availability, and keeps you updated till the package arrives. No hidden markups, just the shop&apos;s invoice delivered with your order.
              </p>
            </div>
            <div className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm shadow-slate-100">
              <h3 className="text-lg font-semibold text-slate-900">What drives us</h3>
              <ul className="mt-2 space-y-2 text-sm text-slate-600">
                <li>• Strengthening ties between residents and local shops.</li>
                <li>• Reliable invoicing and transparent pricing on every order.</li>
                <li>• A support team that feels like a neighbour on speed dial.</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="flex-1">
          <div className="relative mx-auto max-w-md">
            <div className="absolute inset-0 -translate-y-6 translate-x-6 rounded-3xl bg-emerald-200/30 blur-xl" />
            <div className="relative overflow-hidden rounded-3xl border border-slate-100 shadow-xl shadow-slate-200">
              <img
                src={heroImage}
                alt="Team collaborating on hyperlocal delivery"
                className="h-full w-full object-cover opacity-90"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-emerald-500/10 via-transparent to-white/20" />
            </div>
            <div className="relative -mt-10 ml-auto w-52 rounded-2xl border border-white bg-white/80 p-4 text-sm shadow-lg shadow-emerald-100 backdrop-blur">
              <p className="font-semibold text-slate-900">Core Team</p>
              <p className="mt-1 text-slate-600">Product thinkers, logistics geeks, and community managers united to uplift local commerce.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
